/**
 * Define a system-derived measurement (e.g. BMI). Carries only its canonical unit and LOINC code;
 * the derivation itself lives in the consumer that owns the source observations.
 *
 * @__NO_SIDE_EFFECTS__
 */
export function defineDerivedMeasurement(options) {
    return {
        shape: 'derived',
        canonical: options.canonical,
        loinc: options.loinc,
    };
}
//# sourceMappingURL=DerivedMeasurement.js.map